/**
 * @file Intake's one module-level Valtio proxy. `uploads` holds the files sent
 * to intake whose job (or edition) document may not exist yet, keyed by the
 * file's SHA-256 (the job and edition id). Written only by `startPdfIntake`
 * and `startPdfIntakePricebook`, so a drop on Home, Forms or a form page feeds
 * S1's Uploading rows and S2's opening state alike; an entry is deleted when
 * its start task settles with the document in place, and `UploadingRow`'s
 * Remove deletes a failed one. S1 hides an entry by the existence of its
 * document in a listener, never by deleting it at render. Memory only.
 */
import { proxy } from 'valtio';
import type { IntakeUpload } from './intakeUpload.types';

export const intakeState = proxy<{ uploads: Record<string, IntakeUpload> }>({ uploads: {} });
